import { render } from "./index.vue?vue&type=template&id=28521965"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Button/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28521965"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28521965', __exports__)) {
    console.log('reload')
    api.reload('28521965', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=28521965", () => {
    console.log('re-render')
    api.rerender('28521965', render)
  })

}


export default __exports__